import React, { useContext } from 'react';
import { Collapse, Stack } from '@mui/material';
import CollapseHeader from './CollapseHeader';
import { CustomizerContext } from '../CustomizerContext';

const CollapseSection = (props: {
	children?: JSX.Element | JSX.Element[];
	heading: string;
	onDelete?: () => void;
	id: string;
}) => {
	const { sectionId, setSectionId } = useContext(CustomizerContext);
	const isActiveSection = sectionId === props.id;

	return (
		<Stack>
			<CollapseHeader
				open={isActiveSection}
				onClick={() => setSectionId(isActiveSection ? null : props.id)}
				onDelete={props.onDelete}
				heading={props.heading}
			/>
			<Collapse
				sx={{
					px: 2,
					'&.MuiCollapse-root': {
						border: (theme) => `1px solid ${theme.palette.border.divider}`,
					},
				}}
				in={isActiveSection}
			>
				{props.children}
			</Collapse>
		</Stack>
	);
};

export default CollapseSection;
